<template>
    <div id="foldersource" v-on:keyup.esc="$root.$emit('CLOSESOURCEDIALOG')" class="dialog draggable-item bg-light light w-100-sm w-100-md w-75-lg w-50-xl h-50">

        <DialogTitle :title="$t('Configure Backup Source')" :defaultTitle="$t('Configure Backup Source')" :subTitle="$t(source.type_name)" @closeDialog="$root.$emit('CLOSESOURCEDIALOG')" />


        <!--SCELTA PERCORSI-->
        <div v-if="step == 0" class="dialog-content bg-light">
            <SelectedResourcesLayout buttonText="Select files and folders" :singleItem="false" :type="source.type" :isDisabled="false" :list="source.folderSource.paths" :heightPercentage="50" :canCancel="true" @clickFunction="toggleFileSystemSidebar" />

        </div>

        <!--FILTRI-->
        <div class="dialog-content overflow bg-light" v-if="step == 1">

            <BackupSteps :extensionsFilter="true" :fileSizeFilter="true" :type="$ONEServiceType.FileFolder" :client="null" key="filters" @sendOptions="(options) => source.options = options" :mainNodes="source.folderSource.paths" :options="source.options" />

        </div>

        <!--ESCLUSIONI-->
        <div class="dialog-content bg-light overflow" v-if="step == 2">
            <BackupSteps :exclusions="true" key="exclusions" @sendOptions="(options) => source.options = options" :mainNodes="source.folderSource.paths" :options="source.options" :type="$ONEServiceType.FileFolder" :client="null" />

        </div>

        <!--<div class="form-group mt-4" v-if="step == 2">
                <input type="checkbox" v-model="source.options.excludeSubFolders" />
                <label> {{ $t("Do not include any subfolders (only files in the root folder will be copied)") }}</label>
            </div>-->
        <!--</div>-->
        <!--BACKUP-->
        <div class="dialog-content overflow bg-light" v-show="step == 3">

            <div class="form-group">
                <h6 class="text-bold">
                    <span>{{ $t('Backup mode') }}</span>
                </h6>
                <hr>

                <label>{{ $t("Type") }}:</label>
                <select v-model="source.options.backupType" class="select mb-6" data-filter="false">
                    <option v-for="key in Object.keys($root.selectValues.backupTypes)" :value="key" v-bind:key="key">
                        {{ $t($root.selectValues.backupTypes[key]) }}</option>
                </select>

                <label>{{ $t("Number of copies") }}:</label>
                <input class="w-10 input" type="number" v-number v-range="{ 'min': minCopies, 'max': 365 }" v-model.number="source.options.nCopies" />
                <label class="text-muted">{{ $t("Range: {0}-{1}", { '0': minCopies.toString(), '1': 365 }) }}</label>
            </div>

            <div class="form-group">
                <input type="checkbox" v-model="source.options.recreateCompletePath" data-role="checkbox" :data-caption="$t('Recreate the full path of the items')" />
            </div>
            <div class="form-group ">
                <label>{{ $t("Number of parallel threads") }}:</label>
                <input type="number" v-range="{ min: 1, max: 10 }" v-number v-model.number="source.options.nThreads" class="w-10 input" />
                <label class="text-muted">{{ $t("Range: {0}-{1}", { '0': 1, '1': 10 }) }}</label>

            </div>
        </div>

        <!--COMPRESSIONE ZIP-->
        <div class="dialog-content overflow bg-light p-4" v-show="step == 4" :disabled="source.options.backupType == 'U'">
            <BackupSteps :zipCompression="true" key="zipCompression" @sendOptions="(options) => source.options = options" :options="source.options" />
        </div>

        <div class="dialog-actions">
            <div v-if="nextButtonDisabled_message != ''" class="mr-auto w-50 p-0 fg-cobalt" :title="nextButtonDisabled_message">
                <pre class="text-small text-truncate">{{ nextButtonDisabled_message }}</pre>
            </div>

            <button class="button secondary" :disabled="step == 0" @click="setStep(step - 1)">
                {{ $t("Back") }}</button>

            <button class="button secondary" @click="setStep(step + 1)" :disabled="!enableNextButton" v-disable-tooltip:nextButtonDisabled_message>{{ $t("Next") }}</button>

            <!--input type="button" v-on:click="saveSource" :value="$t('Save')" class="button secondary" v-if="enableSaveButton" /-->

            <button class="button secondary ml-2" :disabled="!enableSaveButton" @click="saveSource">{{ $t("Save") }}</button>
            <button class="button secondary" @click="$root.$emit('CLOSESOURCEDIALOG')">{{ $t("Close") }}</button>

        </div>
    </div>
</template>
<script>
import DialogTitle from "../../utils/DialogTitle";
import NoDataAvailable from "../../utils/NoDataAvailable.vue";
import SelectedResourcesLayout from "../../utils/SelectedResourcesLayout.vue";
import { cutText, isValid } from "../../../utils/utilitiesmodule";

import { draggableMixin } from '../../../mixins/draggable-mixin'
import BackupSteps from "../../utils/BackupSteps.vue";
import { FileSystemSidebarConfig } from "../../../models/TreeNode";

export default {
    mixins: [draggableMixin],
    name: "FolderSource",
    props: {
        source: Object,
    },
    components: {
        DialogTitle,
        NoDataAvailable,
        SelectedResourcesLayout,
        BackupSteps
    },
    data() {
        return {
            step: 0,
            drives: [],
            driveSelected: 'C:',
            nextButtonDisabled_message: ""

        }
    },
    computed: {
        minCopies() {
            return ['F', 'U'].includes(this.source.options.backupType) ? 1 : 0
        },
        enableSaveButton() {
            return (this.step == 3 && this.source.options.backupType == 'U') || this.step == 4;
        },
        enableNextButton() {
            //Se la modalità di backup è update full, non permetto di configurare la compressione zip
            if (this.step == 4 || (this.step == 3 && this.source.options.backupType == 'U')) {
                this.nextButtonDisabled_message = "";
                return false;
            }

            if (this.step == 0 && this.source.folderSource.paths.length == 0) {
                this.nextButtonDisabled_message = this.$t('Select at least one item to include in the backup');
                return false;
            }

            this.nextButtonDisabled_message = "";

            return true;

        }
    },
    created() {
        this.$root.$emit('closeFileSystemSidebar');

        //Se la sorgente è stata aperta in creazione, non devo fare nulla
        if (!isValid(this.source.id)) {
            return;
        }
    },

    methods: {
        sendSATestResult(testResult) {
            this.testResult = testResult;
            this.source.id_service_account = testResult.serviceAccount.id;
        },


        setStep(nStep) {
            this.step = nStep;
            this.$root.$emit("closeFileSystemSidebar");
        },

        toggleFileSystemSidebar() {

            var config = FileSystemSidebarConfig.getForSource(
                this.$ONEServiceType.FileFolder,
                null, null
            );

            this.$root.$emit(
                "toggleFileSystemSidebar",
                this.source.folderSource.paths,
                config
            );
        },



        saveSource() {
            let self = this;
            //I paths sono nodi ma devo salvare solamente la struttura {path:'', type:''}
            self.source.folderSource.paths = self.source.folderSource.paths.map(n => {
                return {
                    resID: n.resID,
                    path: n.path,
                    type: n.type
                }
            });


            this.$root.$emit("saveBackupSource", this.source);
        },

        cutText(text, range) {
            return cutText(text, range);
        },

    }
}
</script>